import { NgModule, LOCALE_ID, Injectable, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreComponent } from '@components/bootComponents/wettMobile/core.component';
import { VerificationDialog } from '@components/verification-dialog';
import { NgxBarcodeModule } from 'ngx-barcode';
import { AngularSvgIconModule } from 'angular-svg-icon';
// Routes
import 'hammerjs';
import { MobileRouting } from './app.routing';
import { LiveComponent } from '@components/live.components';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RightMenuComponent } from '@components/right-menu.component';
import { LeftMenuComponent } from '@components/left-menu.component';
import { NavbarComponent } from '@components/navbar.component';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ForgotPasswordComponent } from '@components/forgot-password.component';

import { BottomNavbarComponent } from '@components/bottom-navbar.component';
import { SportsComponent } from '@components/sports.component';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { SliderComponent } from '@components/slider.component';
import { MatchSliderComponent } from '@components/match.slider.component';
import { SlipsComponent } from '@components/slips.component';

import { ChangePasswordComponent } from '@components/change-password.component';

import { CasinoComponent, CasinoItem } from '@components/casino.component';
import { SlipDetailComponent } from '@components/slip-detail.component';
import { AccountLock } from '@components/account-lock.component';
import { SelfLimits } from '@components/self-limits.component';
import { CurrentSlipComponent } from '@components/current-slip.component';

import { EventDetailComponent } from '@components/eventdetail.component';
import { LiveEventDetailComponent } from '@components/liveeventdetail.component';

import { CashoutComponent } from '@components/cashout.component';
import { OutrightsComponent } from '@components/outrights.component';
import { ResultsComponent } from '@components/results.component';
import { InboxComponent } from '@components/inbox.component';
import { TicketDetailComponent } from '@components/ticketdetail.component';
import { InboxDialogComponent } from '@components/inbox.dialog.component';
import { UserProfileComponent } from '@components/user-profile.component';
import { PageComponent } from '@components/page.component';
import { RegisterSuccessComponent } from '@components/register-success.component';
import { MailConfirm } from '@components/mail-confirm.component';
import { RecoverPassword } from '@components/recover-password.component';
import { PreMatchComponent } from '@components/prematch.component';
import { ComparePreMatchComponent } from '@components/compare-prematch.component';
import { LoginCangobetComponent } from '@sharedTemplates/login/cangobet/login-cangobet.component';
import { HomeCangobetComponent } from '@sharedTemplates/home/cangobet/home-cangobet.component';
import { DepositCashtoCodeComponent } from '@components/deposit-cashtocode.component';
// TR Locale
// todo maybe this must to import from environment variables.
import { registerLocaleData, DecimalPipe } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFa from '@angular/common/locales/fa';
import localeAr from '@angular/common/locales/ar-IQ';
import localeVi from '@angular/common/locales/vi';
import localePl from '@angular/common/locales/pl';
import localeRu from '@angular/common/locales/ru';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEl from '@angular/common/locales/el';
import localeBg from '@angular/common/locales/bg';
import localeDa from '@angular/common/locales/da';
import localeSr from '@angular/common/locales/sr';

import localeSq from '@angular/common/locales/sq';
import localeRo from '@angular/common/locales/ro';
import localePt from '@angular/common/locales/pt';
import localeNl from '@angular/common/locales/nl';
import localeMk from '@angular/common/locales/mk';
import localeIt from '@angular/common/locales/it';

import { LeftSportsMenuDialog } from './dialogs/left-sport-menu.dialog';
import { SignOutDialog } from './dialogs/sign-out.dialog';
import { BookingsComponent } from '@components/bookings.component';
import { DataHelper } from '@helpers/data.helper';
import { GroupByTournamentName } from '@pipes/tournament_name';
import { LoadingDialog } from './dialogs/loading.dialog';
import { NavbarTitleComponent } from '@components/navbar.title.component';
import { NavbarFixerDirective } from './directives/navbar.fixer.directive';
import { LanguageChangerDialog } from './dialogs/language.changer.dialog';
import { GroupByName } from '@pipes/groupbyname.pipe';
import { GroupOddsByName } from '@pipes/groupoddsbyname.pipe';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
import { InputFocusDirective } from './directives/input.focus.directive';
import { GroupByEventName } from '@pipes/groupbyeventname.pipe';
import { GroupLiveOddsByName } from '@pipes/groupliveoddsbyname.pipe';
import { BadgeDirective } from './directives/badge.directive';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { DepositCreditCardComponent } from '@components/deposit-creditcard.component';
import { DepositCoinbaseComponent } from '@components/deposit-coinbase.component';
import { WithdrawCoinbaseComponent } from '@components/withdraw-coinbase.component';
import { StorySliderComponent } from '@components/story.slider.component';
import { removeUniquePipe } from '@pipes/reducer.pipe';
import { FiltersPipe } from '@pipes/filters.pipe';
import { LeagueFilterComponent } from '@components/league.filter.component';
import { GroupByTournamentId } from '@pipes/grouplivefixturebytournamentid';
import { IdleDialog } from './dialogs/idle.dialog';
import { GroupBySportId } from '@pipes/groupbysportid';
import { environment, MaterialImports, AritaHammerConfig } from '@environments/environment';
import { DocumentUpload } from '@components/document-upload.components';

import { AccountDownload } from '@components/account-download.component';
import { RecyleView } from './directives/recyle.view';
import { FooterComponent } from '@components/footer.component';
import { LiveMatchComponent } from '@components/livematch.component';
import { LeftSportMenuDesktop } from '@components/left-sport-menu.desktop';
import { CurrentSlipCore } from '@components/current-slip.core';
import { EmptyComponent } from '@components/empty.component';
import { MatchRowComponent } from '@components/match.row.component';
import { MatchesComponent } from '@components/matches.component';
import { HomePrePopularComponent } from '@components/home-prepopular.component';
import { HomeLiveComponent } from '@components/home-live.component';
import { SideBanner } from '@components/side-banner.component';
import { LiveUpcoming } from '@components/live-upcoming.component';
import { DepositPaydoxComponent } from '@components/deposit-paydox.component';
import { DepositPaydox2Component } from '@components/deposit-paydox2.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { DigitOnlyDirective } from './directives/digit.only.directive';
import { WebWorkerService } from './modules/workers/web-worker.service';
import { goToCasinoDialog, LiveCasinoComponent } from '@components/livecasino.component';
import { VirtualgameGRComponent } from '@components/virtualgameGR.component';
import { CasinoLobby } from '@components/casinolobby.component';
import { CasinoXPComponent } from '@components/casinoxp.component';
import { MatchSliderFullWComponent } from '@components/match.slider.fullw.component';
import { LanguageChangerComponent } from '@components/language.changer.component';
import { CasinoBSComponent } from '@components/casinobs.component';
import { CasinoBSLobbyComponent } from '@components/casinobslobby.component';
import { CasinoTrustLobbyComponent } from '@components/casinotrustlobby.component';
import { DepositApcoComponent } from '@components/deposit-apco.component';
import { DepositApcoResultComponent } from '@components/deposit-apco-result.component';
import { DepositPayladoResultComponent } from '@components/deposit-paylado-result.component';

import { CashBackComponent } from '@components/cashback.component';
import { StandingsDialogComponent } from '@components/standings.dialog.component';
import { CashBackInfoComponent } from '@components/cashback-info.component';
import { StatisticsComponent } from '@components/statistics.component';
import { LiveScoreComponent } from '@components/livescore.component';
import { CasinoRuLobbyComponent } from '@components/casinorulobby.component';
import { DepositIrgateComponent } from '@components/deposit-irgate.component';
import { CasinoDSVirtualComponent } from '@components/casinodsvirtual.component';
import { DepositOnlineUeberComponent } from '@components/deposit-onlineueber.component';
import { DepositSofortComponent } from '@components/deposit-sofort.component';
import { HotlineComponent } from '@components/hotline.component';
import { DepositCoinPaymentsComponent } from '@components/deposit-coinpayments.component';
import { CasinoOgzSlotLobbyComponent } from '@components/casinoogzslotlobby.component';
import { DepositPaypalComponent } from '@components/deposit-paypal.component';
import { WithdrawMuchBetterComponent } from '@components/withdraw-muchbetter.component';
import { DepositSkrillComponent } from '@components/deposit-skrill.component';
import { DocumentInfoComponent } from '@components/document-info.component';
import { DocumentInfoUploadComponent } from '@components/document-info-upload.component';
import { DepositNetellerComponent } from '@components/deposit-neteller.component';
import { CasinoVivoLobbyComponent } from '@components/casinovivolobby.component';
import { TransactionsDialog } from '@components/transactions.dialog';
import { CasinoGroupGALobbyComponent } from '@components/casinogroupgalobby.component';
import { PayoutDialog } from '@components/payout.dialog';
import { HomePageDialog } from '@components/home-page-dialog';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GroupOutrightOddsByName } from '@pipes/groupoutrightsoddsbyname.pipe';
import { SettingsComponent } from '@components/settings.component';
import { LeftLinksComponent } from '@components/left.links.component';
import { CasinoGoldenRaceComponent } from '@components/casinogoldenrace.component';
import { WithdrawAuto } from '@components/withdraw-auto';
import { WithdrawAutoBanks } from '@components/withdraw-auto-banks.';
import { WithdrawAutoPaypal } from '@components/withdraw-auto-paypal';
import { WithdrawAutoMuchBetter } from '@components/withdraw-auto-muchbetter';
import { Bonus } from '@components/bonus';
import { TopLeagues } from '@components/top-leagues.component';
import { FavTournaments } from '@components/fav-tournaments.component';
import { LiveSingleEventList } from '@components/live-single-eventlist';
import { AccountCredit } from '@components/account-credit.component';
import { OutsideListener } from './directives/outside.listener.directive';
import { AllSportsMenu } from '@components/all-sports-menu';
import { DatePickerB3, Dropdownb3, InputB3, Textareab3 } from '@components/form.elements';
import { AccountMobile } from '@components/account-mobile';
import { BottomDialog } from '@components/bottom-dialog';
import { ConsentScreenDialog } from '@components/consent-screen-dialog.component';
import { LongTermComponent } from '@components/longterm.component';
import { HeadToHeadDialog } from '@components/headtohead-dialog';
import { QuickTipp } from '@components/quick-tipp';
import { DepositFrameDialog } from '@components/deposit-frame-dialog';
import { GroupByMatchId } from '@pipes/groupbymatchid';
import { MatchDetailDialog } from '@components/match-detail-dialog';
import { WithdrawResultComponent } from '@components/withdraw-result.component';
import { LoadingTicketDialog } from './dialogs/loading-ticket.dialog';
import { NgImageSliderModule } from 'ng-image-slider';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { FileUpload } from '@components/file-upload.element';
import { DataService } from '@services/data.service';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { DepositB3000Component } from '@sharedTemplates/deposit/b3000/deposit-b3000.component';
import { DepositWettarenaComponent } from '@sharedTemplates/deposit/wettarena/deposit-wettarena.component';
import { HelpB3000Component } from '@sharedTemplates/help/b3000/help-b3000.component';
import { HelpWettarenaComponent } from '@sharedTemplates/help/wettarena/help-wettarena.component';
import { HomeB500Component } from '@sharedTemplates/home/b500/home-b500.component';
import { HomeB3000Component } from '@sharedTemplates/home/b3000/home-b3000.component';
import { HomeWettarenaComponent } from '@sharedTemplates/home/wettarena/home-wettarena.component';
import { LoginB500Component } from '@sharedTemplates/login/b500/login-b500.component';
import { LoginB3000Component } from '@sharedTemplates/login/b3000/login-b3000.component';
import { LoginTerminalPeruComponent } from '@sharedTemplates/login/terminalPeru/login-terminalPeru.component';

import { LoginWettarenaComponent } from '@sharedTemplates/login/wetarena/login-wettarena.component';
import { Pay3000B3000Component } from '@sharedTemplates/pay3000/b3000/pay3000-b3000.component';
import { Pay3000WettarenaComponent } from '@sharedTemplates/pay3000/wettarena/pay3000-wettarena.component';
import { RegisterB3000Component } from '@sharedTemplates/register/b3000/register-b3000.component';
import { RegisterWettarenaComponent } from '@sharedTemplates/register/wettarena/register-wettarena.component';
import { WithdrawB3000Component } from '@sharedTemplates/withdraw/b3000/withdraw-b3000.component';
import { WithdrawWettarenaComponent } from '@sharedTemplates/withdraw/wettarena/withdraw-wettarena.component';
import { WithdrawBankB3000Component } from '@sharedTemplates/withdrawBank/b3000/withdraw-bank-b3000.component';
import { WithdrawBankWettarenaComponent } from '@sharedTemplates/withdrawBank/wettarena/withdraw-bank-wettarena.component';
import { WithdrawPaypalB3000Component } from '@sharedTemplates/withdrawPaypal/b3000/withdraw-paypal-b3000.component';
import { WithdrawPaypalWettarenaComponent } from '@sharedTemplates/withdrawPaypal/wettarena/withdraw-paypal-wettarena.component';
import { RightAreaModule } from '@components/cashout/right-area.module';
import { SharedModule } from './modules/shared.module';

import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { ScannerModule } from '@components/scanner/scanner.module';
import { BarcodeDialog } from '@components/barcode.dialog.component';
import { AccountMenuComponent } from '@components/accountMenu/account-menu.component';
import { LanguageDropdownComponent } from '@components/languageDropdown/language-dropdown.component';
import { UtilsModule } from '@app/modules/utils.module';
import { BetStopReasonComponent } from '@components/betStopReason/betStopReason.component';
import { PreVerificationComponent } from '@components/pre-verification.component';
import { WithdrawModalWettarenaComponent } from '@sharedTemplates/withdrawPaypal/wettarena/withdraw-modal-wettarena.component';
import { FavoriesPipe } from '@pipes/favories.pipe';
import { RegisterWettarenaPlComponent } from '@sharedTemplates/register/wettarena-pl/register-wettarena-pl.component';
import { HomeTerminalPeruComponent } from '@sharedTemplates/home/terminalPeru/home-terminalPeru.component';
import { TerminalPeruPrintComponent } from '@sharedTemplates/print/terminalPeru/terminalPeru-print.component';
import { CasinoLuckyStreakComponent } from '@components/casinoluckystreak.component';
import { LugasLimitDialog } from '@components/lugas-limit.dialog';
import { VerificationSowUpload } from '@components/verification-sow.component';
import { ResetLimitDialog } from '@components/reset-limit.dialog';
import { DepositLimitDialog } from '@components/deposit-limit.dialog';
import { WithdrawApcoResultComponent } from './components/withdraw-apco-result.component';

@Injectable()
export class localizationInit {
  public LANGCODE = 'en';

  constructor(private _Localization: LocalizationService) {
    this.LANGCODE = this._Localization.LANGCODE;
    //// console.log("this._Localization.LANGID", this._Localization.LANGID);
    if (this._Localization.LANGID == 2) {
      registerLocaleData(localeEn);
    } else if (this._Localization.LANGID == 3) {
      registerLocaleData(localeTr);
    } else if (this._Localization.LANGID == 6) {
      registerLocaleData(localeDe);
    } else if (this._Localization.LANGID == 8) {
      registerLocaleData(localeFa);
      // jalaali.loadPersian({ usePersianDigits: true });
    } else if (this._Localization.LANGID == 10) {
      //// console.log("Locale registered.");
      registerLocaleData(localeAr);
      this.LANGCODE = 'ar-IQ';
    } else if (this._Localization.LANGID == 4) {
      registerLocaleData(localeAr);
      this.LANGCODE = 'ar-IQ';
    } else if (this._Localization.LANGID == 13) {
      registerLocaleData(localeVi);
      this.LANGCODE = 'vi';
    } else if (this._Localization.LANGID == 5) {
      registerLocaleData(localeRu);
      // jalaali.loadPersian({ usePersianDigits: true });
    } else if (this._Localization.LANGID == 12) {
      registerLocaleData(localePl);
      this.LANGCODE = 'pl';
      //// console.log('pl register');
    } else if (this._Localization.LANGID == 14) {
      registerLocaleData(localeFr);
      this.LANGCODE = 'fr';
    } else if (this._Localization.LANGID == 15) {
      registerLocaleData(localeEl);
      this.LANGCODE = 'el';
    } else if (this._Localization.LANGID == 7) {
      registerLocaleData(localeEs);
      this.LANGCODE = 'es';
    } else if (this._Localization.LANGID == 17) {
      registerLocaleData(localeBg);
      this.LANGCODE = 'bg';
    } else if (this._Localization.LANGID == 19) {
      registerLocaleData(localeDa);
      this.LANGCODE = 'da';
    } else if (this._Localization.LANGID == 20) {
      registerLocaleData(localeSr);
      this.LANGCODE = 'sr';
    } else if (this._Localization.LANGID == 11) {
      registerLocaleData(localePt);
      this.LANGCODE = 'pt';
    } else if (this._Localization.LANGID == 18) {
      registerLocaleData(localeRo);
      this.LANGCODE = 'ro';
    } else if (this._Localization.LANGID == 16) {
      registerLocaleData(localeSq);
      this.LANGCODE = 'sq';
    } else if (this._Localization.LANGID == 21) {
      registerLocaleData(localeNl);
      this.LANGCODE = 'nl';
    } else if (this._Localization.LANGID == 22) {
      registerLocaleData(localeIt);
      this.LANGCODE = 'it';
    } else if (this._Localization.LANGID == 23) {
      registerLocaleData(localeMk);
      this.LANGCODE = 'mk';
    } else {
      registerLocaleData(localeEn);
    }
  }

  getLanguage(): string {
    return this.LANGCODE;
  }
}

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialImports,
    BrowserAnimationsModule,
    MobileRouting,
    ScrollingModule,
    VirtualScrollerModule,
    NgxSkeletonLoaderModule,
    NgImageSliderModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RightAreaModule,
    SharedModule,
    UtilsModule,
    ScannerModule,
    Ng2FlatpickrModule,
    NgxBarcodeModule,
    AngularSvgIconModule.forRoot(),
    NgxSkeletonLoaderModule,
  ],
  declarations: [
    BetStopReasonComponent,
    VerificationDialog,
    CoreComponent,
    LeftMenuComponent,
    RightMenuComponent,
    NavbarComponent,
    SliderComponent,
    BottomNavbarComponent,
    SportsComponent,
    MatchSliderComponent,
    IsoCountriesPipe,
    GroupByTournamentName,
    LeftSportsMenuDialog,
    SignOutDialog,
    LanguageChangerDialog,
    ForgotPasswordComponent,
    BookingsComponent,
    ChangePasswordComponent,
    SlipsComponent,
    LoadingDialog,
    LoadingTicketDialog,
    CasinoComponent,
    NavbarTitleComponent,
    NavbarFixerDirective,
    EventDetailComponent,
    GroupByName,
    GroupOddsByName,
    NavbarFixerDirective,
    InputFocusDirective,
    BadgeDirective,
    RecyleView,
    SlipDetailComponent,
    AccountLock,
    SelfLimits,
    CurrentSlipComponent,
    GroupByEventName,
    LiveEventDetailComponent,
    GroupLiveOddsByName,
    GroupOutrightOddsByName,
    CashoutComponent,
    LiveComponent,
    DepositCreditCardComponent,
    DepositCoinbaseComponent,
    DepositPaydoxComponent,
    DepositPaydox2Component,
    DepositIrgateComponent,
    WithdrawCoinbaseComponent,
    GroupByTournamentId,
    StorySliderComponent,
    removeUniquePipe,
    FiltersPipe,
    LeagueFilterComponent,
    OutrightsComponent,
    ResultsComponent,
    InboxComponent,
    TicketDetailComponent,
    InboxDialogComponent,
    IdleDialog,
    GroupBySportId,
    UserProfileComponent,
    DocumentUpload,
    PageComponent,
    RegisterSuccessComponent,
    CasinoItem,
    AccountDownload,
    FooterComponent,
    MailConfirm,
    PreMatchComponent,
    ComparePreMatchComponent,
    LiveMatchComponent,
    RecoverPassword,
    LeftSportMenuDesktop,
    CurrentSlipCore,
    EmptyComponent,
    MatchRowComponent,
    MatchesComponent,
    HomePrePopularComponent,
    HomeLiveComponent,
    SideBanner,
    LiveUpcoming,
    DigitOnlyDirective,
    LiveCasinoComponent,
    VirtualgameGRComponent,
    goToCasinoDialog,
    CasinoLobby,
    CasinoXPComponent,
    MatchSliderFullWComponent,
    LanguageChangerComponent,
    CasinoBSComponent,
    CasinoBSLobbyComponent,
    CasinoTrustLobbyComponent,
    DepositApcoComponent,
    DepositApcoResultComponent,
    WithdrawApcoResultComponent,
    DepositPayladoResultComponent,
    WithdrawResultComponent,
    CashBackComponent,
    StandingsDialogComponent,
    CashBackInfoComponent,
    StatisticsComponent,
    LiveScoreComponent,
    CasinoRuLobbyComponent,
    CasinoDSVirtualComponent,
    DepositOnlineUeberComponent,
    DepositSofortComponent,
    HotlineComponent,
    DepositCoinPaymentsComponent,
    CasinoOgzSlotLobbyComponent,
    DepositCashtoCodeComponent,
    DepositPaypalComponent,
    WithdrawMuchBetterComponent,
    DepositSkrillComponent,
    DocumentInfoComponent,
    DocumentInfoUploadComponent,
    DepositNetellerComponent,
    CasinoVivoLobbyComponent,
    CasinoLuckyStreakComponent,
    TransactionsDialog,
    LugasLimitDialog,
    ResetLimitDialog,
    CasinoGroupGALobbyComponent,
    CasinoGoldenRaceComponent,
    PayoutDialog,
    HomePageDialog,
    SettingsComponent,
    LeftLinksComponent,
    WithdrawAuto,
    WithdrawAutoBanks,
    WithdrawAutoPaypal,
    WithdrawAutoMuchBetter,
    Bonus,
    TopLeagues,
    InputB3,
    Dropdownb3,
    Textareab3,
    DatePickerB3,
    OutsideListener,
    FavTournaments,
    LiveSingleEventList,
    AccountCredit,
    AllSportsMenu,
    AccountMobile,
    BottomDialog,
    ConsentScreenDialog,
    MatchDetailDialog,
    LongTermComponent,
    HeadToHeadDialog,
    DepositFrameDialog,
    QuickTipp,
    GroupByMatchId,
    FileUpload,
    DepositB3000Component,
    DepositWettarenaComponent,
    HelpB3000Component,
    HelpWettarenaComponent,
    HomeB500Component,
    HomeB3000Component,
    HomeTerminalPeruComponent,
    HomeWettarenaComponent,
    LoginB500Component,
    LoginTerminalPeruComponent,
    LoginB3000Component,
    LoginWettarenaComponent,
    Pay3000B3000Component,
    Pay3000WettarenaComponent,
    RegisterB3000Component,
    RegisterWettarenaComponent,
    WithdrawB3000Component,
    WithdrawWettarenaComponent,
    WithdrawBankB3000Component,
    WithdrawBankWettarenaComponent,
    WithdrawPaypalB3000Component,
    WithdrawPaypalWettarenaComponent,
    BarcodeDialog,
    AccountMenuComponent,
    LanguageDropdownComponent,
    VerificationSowUpload,
    PreVerificationComponent,
    WithdrawModalWettarenaComponent,
    RegisterWettarenaPlComponent,
    FavoriesPipe,
    TerminalPeruPrintComponent,
    LoginCangobetComponent,
    HomeCangobetComponent,
    ConsentScreenDialog,
    SelfLimits,
    WithdrawBankWettarenaComponent,
    WithdrawPaypalWettarenaComponent,
    DepositLimitDialog,
  ],
  bootstrap: [CoreComponent],
  providers: [
    localizationInit,
    {
      provide: LOCALE_ID,
      deps: [localizationInit],
      useFactory: localizationInit => localizationInit.getLanguage(),
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: AritaHammerConfig,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
      useValue: undefined,
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },
    ApiService,
    UiHelper,
    UserHelper,
    LocalizationService,
    // SignalRService
    SignalrServiceLegacy,
    ScrollDispatcher,
    DataHelper,
    DataService,
    RouteGuardHelper,
    WebWorkerService,
    DecimalPipe,
  ],
})
export class AppModule {}
